import { queryClient } from '@/config/query-client.config';
import {
  CreateRecommendationRequest,
  UpdateRecommendationRequest,
} from '@repo/types/src/recommendation';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createRecommendation,
  deleteRecommendation,
  getAllRecommendations,
  updateRecommendation,
} from './recommendation.queries';
import { recommendationQueryKeys } from './recommendation.query-keys';

export const useGetRecommendations = () => {
  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: recommendationQueryKeys.all,
    queryFn: getAllRecommendations,
  });

  return {
    recommendations: data || [],
    isError,
    isLoading,
    refetch,
  };
};

export const useCreateRecommendation = () => {
  return useMutation({
    mutationFn: (payload: CreateRecommendationRequest) =>
      createRecommendation(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recommendationQueryKeys.all });
    },
  });
};

export const useUpdateRecommendation = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateRecommendationRequest;
    }) => updateRecommendation(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recommendationQueryKeys.all });
    },
  });
};

export const useDeleteRecommendation = () => {
  return useMutation({
    mutationFn: (id: number) => deleteRecommendation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recommendationQueryKeys.all });
    },
  });
};
